export default __webpack_public_path__ + "static/media/ic_programa_paciente.a3642e7f.svg";